import React, { useEffect, useState, useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import "./index.css";

function HomeTestimonials() {
    const [reviews, setReviews] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [infiniteStart, setInfiniteStart] = useState(1);

    // Create a ref to store references to each testimonial text container
    const textRefs = useRef([]);

    const fetchReviews = async (page) => {
        setIsLoading(true);
        try {
            const response = await axios.post('https://exj3cjwpp3.execute-api.us-west-1.amazonaws.com/prod/Swmc-Social-Survey', {
                pageNumber: page
            });

            if (response.status === 200) {
                const newTestimonials = response.data;
                if (Array.isArray(newTestimonials)) {
                    const transformedReviews = newTestimonials.map((ele) => {
                        const date = new Date(ele.survey_completed_on);
                        date.setDate(date.getDate() - 1);
                        const monthNames = [
                            "January", "February", "March", "April", "May", "June",
                            "July", "August", "September", "October", "November", "December"
                        ];
                        const formattedDate = `on ${monthNames[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
                        const lastName = `${ele.customer_last_name.charAt(0)}.`;
                        const firstName = ele.customer_first_name;

                        return {
                            id: ele.id,
                            text: ele.review,
                            rating: ele.rating,
                            date: formattedDate,
                            author: `${lastName}, ${formattedDate}`,
                            name: ` ${firstName} ${lastName}`,
                        };
                    });

                    // Filter reviews to only show those with more than 30 words
                    const filteredReviews = transformedReviews.filter(review => countWords(review.text) >= 30);

                    setReviews([...reviews, ...filteredReviews]);
                    // getTestimonialStyle();
                    if (transformedReviews.length >= 8) {
                        setPageNumber(pageNumber + 1);
                    }
                }
            } else {
                throw new Error('Request failed');
            }
        } catch (err) {
            console.error(err);
        }
        setIsLoading(false);
    };

    // Helper function to count words in a text
    const countWords = (text) => {
        return text.trim().split(/\s+/).length;
    };

    const getNewTestimonials = (page) => {
        fetchReviews(page);
    };

    useEffect(() => {
        getNewTestimonials(infiniteStart);
    }, [infiniteStart]);

    const handleSlideChange = () => {
        setTimeout(() => {
            if (infiniteStart < 500) {
                const nextPage = pageNumber + 1;
                setPageNumber(nextPage);
                setInfiniteStart(infiniteStart + 1);
                getNewTestimonials(nextPage);
            }
        }, 500);
    };

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, padding: '0.5rem', background: 'transparent', borderRadius: '50%' }}
                onClick={onClick}
            >
                <span style={{ border: 'solid var(--primary-purple-1)', borderWidth: '0 2px 2px 0', padding: '4px', transform: 'rotate(-45deg)', display: 'inline-block' }} className='next-arrow-span'></span>
            </div>
        );
    }

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, padding: '0.5rem', background: 'transparent', borderRadius: '50%' }}
                onClick={onClick}
            >
                <span style={{ border: 'solid var(--primary-purple-1)', borderWidth: '0 2px 2px 0', padding: '4px', transform: 'rotate(135deg)', display: 'inline-block' }} className='prev-arrow-span'></span>
            </div>
        );
    }


    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        lazyLoad: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        beforeChange: (oldIndex, newIndex) => {
            handleSlideChange();
        },
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    autoplay: true,
                    autoplaySpeed: 3000,
                },
            },
        ],
    };

    // const getTestimonialStyle = (text, ref) => {
    //     const wordCount = countWords(text);
    //     const height = ref ? ref.clientHeight : 0;
    //     if (height > 180) {
    //         return { maxHeight: '180px', overflowY: 'scroll' };
    //     }
    //     return {};
    // };

    return (
        <section className="HomeTestimonials-section" id='testimonials'>
            <Container className="HomeTestimonials-container">
                <h3 className="HomeTestimonials-heading">Testimonials</h3>
                {isLoading && reviews.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '2rem' }}>
                        <Spinner />
                        <div>Loading testimonials...</div>
                    </div>
                ) : (
                    <Slider {...settings}>
                        {reviews.map((testimonial, index) => (
                            <div key={testimonial.id} className="testimonial-slide">
                                {/* Assign ref to the specific testimonial div */}
                                <div
                                    className="testimonial-text"
                                    // style={getTestimonialStyle(testimonial.text, textRefs.current[index])}
                                    ref={el => textRefs.current[index] = el}
                                >
                                    {testimonial.text}
                                </div>
                                <div className="testimonial-name">{testimonial.name}</div>
                            </div>
                        ))}
                    </Slider>
                )}
                <div className="HomeTestimonials-button-wrapper">
                    <Button
                        className="hometestimonials-button"
                        as={Link}
                        to="/testimonials"
                        variant="warning"
                    >
                        Read More
                    </Button>
                </div>
            </Container>
        </section>
    );
}

export default HomeTestimonials;
